import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import {
  Billing,
  Home,
  Register,
  Research,
  Activity,
  Capturer,
  MediaManagementDashboard,
  MediaCampaignOverview,
  AccountInsights,
} from './pages'
import { AppWrapper, ContextProvider } from './components'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'

function App() {
  return (
    <div className="App">
      <Router>
        <ContextProvider>
          <AppWrapper>
            <Routes className="px-0">
              <Route path="/" element={<Home />} />
              <Route path="/Capturer" element={<Capturer />} />
              <Route path="/Billing" element={<Billing />} />
              <Route path="/Research" element={<Research />} />
              <Route path="/Activity" element={<Activity />} />
              <Route path="/register" element={<Register />} />
              <Route path="/Media" element={<MediaManagementDashboard />} />
              <Route
                path="/MediaCampaigns"
                element={<MediaCampaignOverview />}
              />
              <Route path="/AccountInsights" element={<AccountInsights />} />
              {/* <Route path="/module1" element={<Module1 />} />
              <Route path="/module2" element={<Module2 />} />
              <Route path="/module3" element={<Module4 />} />
              <Route path="/module4" element={<Module3 />} /> */}
              <Route path="/:project_id" element={<Home />} />
              <Route path="/*" element={<Home />} />
            </Routes>
          </AppWrapper>
        </ContextProvider>
      </Router>
    </div>
  )
}

export default App
